<template>
  <div class="item" v-if="item.hidden !== 'Y'">
    <template v-if="item.children && item.children.length !== 0">
      <el-submenu :index="item.path">
        <template slot="title">
          <i :class="isCollapse ? `${item.icon} menu-close` : `${item.icon} menu-open`"></i>
          <span>{{ item.name }}</span>
        </template>
        <Item
          v-for="(child, index) in item.children"
          :key="child.menuId"
          :item="child"
          :len="index"
          :path="child.path"
        />
      </el-submenu>
    </template>
    <template v-else>
      <el-menu-item :index="item.path">
        <i class="item-cicle" :style="colorList[len % 6]"></i>
        <span slot="title">{{ item.name }}</span>
      </el-menu-item>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Item',
  props: {
    item: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      default: '',
    },
    len: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      colorList: [
        'background: rgba(255,83,83,1);',
        'background: rgba(255,142,83,1);',
        'background: rgba(83,255,187,1);',
        'background: rgba(83,197,255,1);',
        'background: rgba(115,83,255,1);',
        'background: rgba(234,91,232,1);',
      ],
    };
  },
  computed: {
    ...mapGetters({
      pathLimits: 'pathLimits',
      routes: 'menuList',
      isCollapse: 'isCollapse',
    }),
  },
};
</script>

<style lang="less" scoped>
  .item {
  }
  .menu-close {
    margin: 0 12px;
    font-size: 16px;
  }
  .menu-open {
    margin-right: 8px;
    font-size: 16px;
  }
  .item-cicle {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 8px;
    margin-bottom: 1px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/layout/Item.vue